/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForOciTenancy extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForOciTenancy");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForOciTenancy.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForOciTenancy>): ServiceAccountNativeDetailsForOciTenancy {
        let obj = Object.assign(new ServiceAccountNativeDetailsForOciTenancy(), model);
        ServiceAccountNativeDetailsForOciTenancy.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForOciTenancy>): ServiceAccountNativeDetailsForOciTenancy {
        if (!model) return null;
        return ServiceAccountNativeDetailsForOciTenancy.newInstance(<ServiceAccountNativeDetailsForOciTenancy> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForOciTenancy) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForOciTenancy.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForOciTenancy): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForOciTenancy.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenancy Id. This is a required field.
     */
    tenancy_id: string;

    /**
     * Default Region. This is a required field.
     */
    region: string;

    /**
     * Tenancy Name.
     */
    tenancy_name: string;

}
